// libraries
import React from 'react';

// utils
import { getField } from 'src/utils/EntryUtil';

// types
import { ReferencedEntry } from 'contentful';
import { DynamicAssembly as IContentfulDynamicAssembly, DynamicType } from 'src/api/contentful/contentTypes.cloverdotcom';

// components
import { JobPost } from 'src/components/JobPost/JobPost';
import { CareersListingModule } from '../CareersListingModule/CareersListingModule';
import { ResellerGrid } from '../ResellerGrid/ResellerGrid';

export interface IDynamicAssembly extends React.AllHTMLAttributes<HTMLElement> {
  entry?: ReferencedEntry<IContentfulDynamicAssembly>;
}

const DynamicAssembly: React.FunctionComponent<IDynamicAssembly> = props => {
  const assemblyType = getField(props.entry, 'type');
  switch (assemblyType) {
    case DynamicType.CAREERS:
      return <CareersListingModule {...props} />;
    case DynamicType.SHOPPING_FOOTER:
      return <ResellerGrid {...props} />;
    case DynamicType.JOB_POST:
      return <JobPost {...props} />;
    default:
      return null;
  }
};

export { DynamicAssembly };
